import { render } from "./DetailTabWork.vue?vue&type=template&id=fb7b2134"
import script from "./DetailTabWork.vue?vue&type=script&lang=js"
export * from "./DetailTabWork.vue?vue&type=script&lang=js"

import exportComponent from "/Users/chenjun/Desktop/myProject/pbl-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__